// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xow3","largestCol":"styles_largestCol__3vQSs","smallestCol":"styles_smallestCol__12Xu8"};